var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgfunds-fund-managers bgfunds-main-module"},_vm._l((_vm.data.people),function(person,index){return _c('div',{key:index},[_c('FundManager',{attrs:{"manager":person}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }